var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('EnrollList',{ref:"enrollList",attrs:{"type":"join"}}),_vm._v(" "),_c('div',{staticClass:"save-btn"},[_c('div',{style:({ background: _vm.theme_color, borderColor: _vm.theme_color }),on:{"click":_vm.enrollData}},[_vm._v("完成，继续答题")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e3de62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enroll/enroll.vue
// module id = null
// module chunks = 